var map = {
	"./Grafik_Computer_Frage_2.svg": 789,
	"./Grafik_Diagramm_Frage_4.svg": 501,
	"./Grafik_Elektrogeraete_Frage_1.svg": 250,
	"./Grafik_Erde_Frage_1.svg": 227,
	"./Grafik_Foodwaste_Frage_5.svg": 945,
	"./Grafik_Haus_Frage_1.svg": 876,
	"./Grafik_Kaffe_Frage_3.svg": 112,
	"./Grafik_Kuh_Frage_1.svg": 353,
	"./Grafik_Molekuel_Frage_7.svg": 420,
	"./Grafik_Tshirt_Frage_6.svg": 574,
	"./Klimaquiz_Keyvisual.svg": 328
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 454;